import { useCallback } from 'react';
import { useGetDisplayWebContentSelector } from './useGetDisplayWebContentSelector';

export const useGetTemplateSelector = () => {
  const getDisplayWebContent = useGetDisplayWebContentSelector();

  return useCallback((id: string) => getDisplayWebContent(id)?.template, [getDisplayWebContent]);
};
